import React from "react"
import Header from "./Header"
import Footer from "./Footer"
import Sidebar from "./Sidebar"
import { useAuth } from "../../context/AuthContext"
import UpdateNotification from "../common/UpdateNotification"

const Layout = ({
  children,
  showSidebar = false,
  showEExpert = false,
  repairHistory,
  loading,
  repairId,
  sessionId,
  appLookups,
  onFileUpload,
  onCloseEExpert,
  refreshRepairDetails,
  isDynamic = false,
  setLoading = () => {}
}) => {
  const { isAdmin, isAuthenticated } = useAuth()

  // Don't render anything if not authenticated
  if (!isAuthenticated) {
    return null
  }

  return (
    <div
      className={`min-vh-100 d-flex flex-column app-layout ${showSidebar ? "has-sidebar" : ""} ${
        isAdmin() ? "is-admin" : ""
      } ${showEExpert ? "e-expert-active" : ""}`}>
      <div className="grid-background">
        <Header />

        <div className="main-content-wrapper">
          <main className="h-100">
            <div className="content-glass">{children}</div>
          </main>

          {showSidebar && (
            <Sidebar
              repairHistory={repairHistory}
              loading={loading}
              showEExpert={showEExpert}
              repairId={repairId}
              sessionId={sessionId}
              appLookups={appLookups}
              onFileUpload={onFileUpload}
              onCloseEExpert={onCloseEExpert}
              refreshRepairDetails={refreshRepairDetails}
              isDynamic={isDynamic}
              setLoading={setLoading}
            />
          )}
        </div>

        <Footer />
        <UpdateNotification />
      </div>
    </div>
  )
}

export default Layout
